import Vue from 'vue';

const state = () => ({
    surveyData: {}
});

// getters
const getters = {
    /**
     * Whether the given step has been registered yet
     * @param {String} stepName The name of the step to look up
     * @returns {Boolean}
     */
    hasStepData: (state) => (stepName) => (stepName && state.surveyData.hasOwnProperty(stepName)) ?? false,
    /**
     * The field values for the given step
     * @param {String} stepName The name of the step to look up
     * @returns {Object} The field values, keyed by fieldId
     */
    stepFieldValues: (state) => (stepName) => state.surveyData[stepName] ?? {},
    /**
     * Whether all field values in the given step are valid
     * @param {String} stepName The name of the step to look up
     * @returns {Boolean}
     */
    isStepValid: (state, getters) => (stepName) => (stepName && Object.values(getters.stepFieldValues(stepName))
        .every((v) => v.valid)) ?? false,
    /**
     * Whether any field values in the given step are validating
     * @param {String} stepName The name of the step to look up
     * @returns {Boolean}
     */
    isStepValidating: (state, getters) => (stepName) => (stepName && Object.values(getters.stepFieldValues(stepName))
        .some((v) => v.validating)) ?? false,
    /**
     * The combined field values of all survey steps
     * @returns {Object} The field values, keyed by fieldId
     */
    allFieldValues: (state) => {
        let allFieldValues = {};
        Object.values(state.surveyData).forEach((stepData) => {
            allFieldValues = { ...allFieldValues, ...stepData };
        });
        return allFieldValues;
    },
    /**
     * Whether all steps are valid
     * @returns {Boolean}
     */
    allStepsValid: (state, getters) => Object.values(getters.allFieldValues).every((v) => v.valid)
};

// actions
const actions = {

};

// mutations
const mutations = {
    /**
     * Sets field value data for a given field and step name.
     * If the field value already exists in the given step, it will be updated.
     * @param {Object} state
     * @param {Object} payload Step name and field data
     */
    setFieldData(state, { stepName, fieldData }) {
        const dataToSet = {
            value: { ...fieldData.value },
            isEmpty: fieldData.isEmpty,
            valid: fieldData.valid,
            validating: fieldData.validating
        };
        if (typeof state.surveyData[stepName] === 'object') {
            // If the step has been registered, set the field value
            Vue.set(state.surveyData[stepName], fieldData.fieldId, dataToSet);
        } else {
            // If the step has not been registered, create it and set the field value
            Vue.set(state.surveyData, stepName, {
                [fieldData.fieldId]: dataToSet
            });
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
